import React from "react"
import axios from 'axios'
import { MDCLinearProgress } from '@material/linear-progress';
import $ from "jquery";
import { MDCDataTable } from '@material/data-table';
import { MDCTextField } from '@material/textfield';
import { MDCSnackbar } from '@material/snackbar';
import { MDCTabBar } from '@material/tab-bar';

var snackbar

function roundPlus(number) { if (isNaN(number)) return false; var m = Math.pow(10, 2); return Math.round(number * m) / m; }

class UsersListBox extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.loadServices()
  }

  render(props) {

    const { error, isLoaded, items } = this.props.state;
    if (error) {
      return <div>Ошибка: {error.message}</div>;
    } else if (!isLoaded) {
      return <div>Загрузка...</div>;
    } else {
      return (
        <div className="ibox" style={{ flex: "0 0 1000px", minWidth: "100%", margin: "24px 24px 24px 0", overflowX: "auto" }}>
          <h3 className="ibox_title" style={{ paddingRight: "10px" }}>Пользователи</h3>
          <div className="ibox_content" style={{ padding: "0" }}>
              <div className="mdc-data-table" style={{ width: "100%" }}>
                <table className="mdc-data-table__table" aria-label="Dessert calories">
                  <thead>
                    <tr className="mdc-data-table__header-row">
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">ID</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Логин</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Баланс</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Реферер</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Рефералов</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Заработано</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Заказов</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Потрачено</th>
                    </tr>
                  </thead>
                  <tbody className="mdc-data-table__content" id="historyTable">
                    {items.map(item => (<tr className="mdc-data-table__row">
                      <td className="mdc-data-table__cell"> {item.id}</td>
                      <td className="mdc-data-table__cell"> {item.login}</td>
                      <td className="mdc-data-table__cell"> {roundPlus(item.balance)}$</td>
                      <td className="mdc-data-table__cell"> {item.ref}</td>
                      <td className="mdc-data-table__cell"> {item.refCount}</td>
                      <td className="mdc-data-table__cell"> {roundPlus(item.refProfit)}$</td>
                      <td className="mdc-data-table__cell"> {item.orders}</td>
                      <td className="mdc-data-table__cell"> {roundPlus(item.spent)}$</td>
                    </tr>
                    ))}
                  </tbody>
                </table>
            </div>
          </div>
        </div>
      );
    }


  }
}

class UsersTab extends React.Component {
  constructor(props) {
    super(props);
    this.loadServices = this.loadServices.bind(this)

    this.state = {
      error: null,
      isLoaded: false,
      items: []
    }

  }

  componentDidMount() {

  }

  loadServices() {
    axios.get("https://nakrutkatop.com:443/api/admin/users", { withCredentials: true })
      .then(res => {
        this.setState({
          isLoaded: true,
          items: res.data.users
        }, () => { new MDCDataTable(document.querySelector('.mdc-data-table'));
        document.getElementById("mainContent").style.opacity = 1
       })
      })
  }

  render(props) {
    return <div id="mainContent" style={{ opacity: "0", transition: "1s opacity" }}>
      <div className="irow" style={{ display: "flex", flexWrap: "wrap" }}>
        <UsersListBox loadServices={this.loadServices} state={this.state} />
      </div>
    </div>
  }
}

export default UsersTab